import styled from "@emotion/styled";
import { theme } from "@xometry/xometry_loft";

export const CustomFieldTemplateContainer = styled.div<{
  isHalfWidth: boolean;
}>`
  display: inline-flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;

  ${theme.mediaQueries.medium} {
    flex-basis: ${({ isHalfWidth }) => (isHalfWidth ? "49%" : "100%")};
    box-sizing: border-box;
  }
`;
